import { render, staticRenderFns } from "./emoneyBeneficiaryComponent.vue?vue&type=template&id=5ed36e86&"
import script from "./emoneyBeneficiaryComponent.vue?vue&type=script&lang=js&"
export * from "./emoneyBeneficiaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports